import Seo from "@/components/Seo";
import { PageHero } from "@/components/Sections";
import { COMPANY } from "@/lib/content";

const Section = ({ title, children }) => (
  <section className="mt-12">
    <h2 className="font-cabinet text-xl font-bold tracking-tight">{title}</h2>
    <div className="mt-4 text-sm md:text-base text-soot leading-relaxed space-y-4">{children}</div>
  </section>
);

export const Privatlivspolitik = () => (
  <>
    <Seo
      title="Privatlivspolitik | Al Maler Mester ApS"
      description="Læs hvordan Al Maler Mester ApS behandler personoplysninger i forbindelse med henvendelser fra erhvervskunder."
    />
    <PageHero overline="Juridisk" title="Privatlivspolitik" />
    <div className="max-w-[800px] mx-auto px-5 md:px-10 pb-24 md:pb-32" data-testid="privacy-content">
      <Section title="Dataansvarlig">
        <p>
          {COMPANY.name}, CVR {COMPANY.cvr}, {COMPANY.street}, {COMPANY.city}, tlf. {COMPANY.phone}, er
          dataansvarlig for behandlingen af de personoplysninger, vi modtager i forbindelse med henvendelser
          til virksomheden.
        </p>
      </Section>
      <Section title="Hvilke oplysninger indsamler vi?">
        <p>
          Når I kontakter os via hjemmesidens formular, telefon eller e-mail, behandler vi de oplysninger, I
          giver os: virksomhedsnavn, kontaktperson, CVR-nummer, telefonnummer, e-mailadresse, projektadresse
          samt beskrivelse og eventuelle vedhæftede billeder eller dokumenter vedrørende opgaven.
        </p>
      </Section>
      <Section title="Formål og opbevaring">
        <p>
          Oplysningerne bruges udelukkende til at behandle jeres henvendelse, udarbejde tilbud og gennemføre
          aftalt arbejde. Vi videregiver ikke oplysninger til tredjemand uden samtykke, medmindre det er
          nødvendigt for at opfylde en aftale eller følger af lovgivningen. Henvendelser, der ikke fører til en
          aftale, slettes løbende.
        </p>
      </Section>
      <Section title="Jeres rettigheder">
        <p>
          I har ret til at få indsigt i de oplysninger, vi behandler om jer, og til at få dem berigtiget eller
          slettet. Kontakt os på {COMPANY.phone}, hvis I ønsker at gøre brug af jeres rettigheder.
        </p>
      </Section>
    </div>
  </>
);

export const Cookiepolitik = () => (
  <>
    <Seo
      title="Cookiepolitik | Al Maler Mester ApS"
      description="Al Maler Mester ApS anvender kun teknisk nødvendige cookies på hjemmesiden. Læs mere i vores cookiepolitik."
    />
    <PageHero overline="Juridisk" title="Cookiepolitik" />
    <div className="max-w-[800px] mx-auto px-5 md:px-10 pb-24 md:pb-32" data-testid="cookie-content">
      <Section title="Brug af cookies">
        <p>
          Denne hjemmeside anvender udelukkende teknisk nødvendige cookies, der sikrer, at siden fungerer
          korrekt. Vi bruger ikke cookies til markedsføring, statistik eller sporing af besøgende.
        </p>
      </Section>
      <Section title="Teknisk nødvendige cookies">
        <p>
          Nødvendige cookies bruges til at huske grundlæggende funktioner på siden. De kan ikke fravælges, da
          hjemmesiden ellers ikke vil fungere efter hensigten. Disse cookies indeholder ikke personoplysninger
          og deles ikke med tredjemand.
        </p>
      </Section>
      <Section title="Spørgsmål">
        <p>
          Har I spørgsmål til vores brug af cookies, er I velkommen til at kontakte os på {COMPANY.phone}.
        </p>
      </Section>
    </div>
  </>
);
